(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/route-result/assets/javascripts/components/skeleton/result-distribution-skeleton.js') >= 0) return;  svs.modules.push('/components/tipsen/route-result/assets/javascripts/components/skeleton/result-distribution-skeleton.js');
"use strict";

const CenterToScreen = svs.components.tipsen.centerToScreen.CenterToScreen;
const _svs$components$lbUi = svs.components.lbUi,
  SkeletonLine = _svs$components$lbUi.SkeletonLine,
  SkeletonCircle = _svs$components$lbUi.SkeletonCircle;
const ResultDistributionFallback = () => React.createElement(CenterToScreen, null, React.createElement("div", {
  className: "skeleton-distribution-container skeleton-distribution-container-title"
}, React.createElement(SkeletonLine, {
  className: "skeleton-distribution"
}), React.createElement(SkeletonLine, {
  className: "skeleton-distribution"
}), React.createElement(SkeletonLine, {
  className: "skeleton-distribution"
})), React.createElement("div", {
  className: "skeleton-distribution-container"
}, React.createElement(SkeletonCircle, {
  className: "skeleton-distribution-cicle",
  size: 25
}), React.createElement(SkeletonLine, {
  className: "skeleton-distribution skeleton-distribution-middle"
}), React.createElement(SkeletonLine, {
  className: "skeleton-distribution"
})), React.createElement("div", {
  className: "skeleton-distribution-container"
}, React.createElement(SkeletonCircle, {
  className: "skeleton-distribution-cicle",
  size: 25
}), React.createElement(SkeletonLine, {
  className: "skeleton-distribution skeleton-distribution-middle"
}), React.createElement(SkeletonLine, {
  className: "skeleton-distribution"
})), React.createElement("div", {
  className: "skeleton-distribution-container"
}, React.createElement(SkeletonCircle, {
  className: "skeleton-distribution-cicle",
  size: 25
}), React.createElement(SkeletonLine, {
  className: "skeleton-distribution skeleton-distribution-middle"
}), React.createElement(SkeletonLine, {
  className: "skeleton-distribution"
})));
setGlobal('svs.components.tipsen.routeResult.ResultDistributionFallback', ResultDistributionFallback);

 })(window);